import React from "react";
import { useNavigate } from "react-router-dom";
import icon1 from "../../assets/images/ingradiants1.png";
import icon2 from "../../assets/images/ingradiants2.png";
import icon3 from "../../assets/images/ingradiant3.png";

import left from "../../assets/images/gradiatsLeftImg.png";
import right from "../../assets/images/gradiantsRightImg.png";

const FreshIngredientsSection = () => {
  const history = useNavigate();
  return (
    <section id="fresh-ingredients">
      <img src={left} alt=""  className="imgGrad left-gra"/>
      <img src={right} alt="" className="imgGrad right-gra"/>
      <div className="wrapper">
        <div className="ingredients-content">
          <p>
            Made Fresh When You Order <img src={icon1} alt="" className="gra-icon"/>
            From Breakfast to Grinders,
          </p>
          <p>
            Grill Favorites And More <img src={icon3} alt="" className="gra-icon"/>
            No Shortcuts — Just Real Food Done Right Fast <img src={icon2} alt="" className="gra-icon"/>
          </p>

          <div className="ingredients-actions">
            <button className="primary" onClick={() => history("/menu")}>EXPLORE OUR MENU</button>
            <button className="secondary" onClick={() => history("/special?today=true")}>VIEW TODAY’S SPECIAL</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreshIngredientsSection;
